import gtm from '~/services/gtm.client';

import UserEvent from './UserEvent';

type EventData = {
  banner_id: string;
  banner_name: string;
  banner_position: string;
  isBot: boolean;
};

class BannerImpressionEvent extends UserEvent<EventData> {
  sendToGtm() {
    gtm.pushToDataLayer({
      banner_id: this.data.banner_id,
      banner_name: this.data.banner_name,
      banner_position: this.data.banner_position,
      event: 'view_promotion'
    });
  }
}

export default BannerImpressionEvent;
